import options from './single-device.component';
import DashboardChart from '../dashboard-chart';

export default {
    selector: 'dtSingleDeviceCard',
    options,
    DashboardChart
};
